#itt-sl-ucl, #root, #sl-app {
  .price-info-container {
    position: relative;
    display: inline-flex;
    vertical-align: middle;
    margin: 0 0.3em;

    .price-info-trigger {
      appearance: none;
      background: transparent;
      border: none;
      padding: 0;
      width: auto;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      color: var(--sales-text-color, var(--txt-dark, inherit));

      svg {
        width: 18px;
        height: 18px;
      }
    }
  }

  .price-info-popup {
    background: #fff;
    color: var(--txt-dark, #000);
    border: 1px solid var(--border, #e0e0e0);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    width: 300px; // keep in sync with POPUP_WIDTH in PriceInfo.js
    text-align: left;
    font-size: 14px;
    line-height: 1.4;
    z-index: 10000;

    &.align-right {
      transform: translateX(-100%) translateX(20px);

      &::before {
        right: 5px;
        left: auto;
      }
    }

    &.align-left {
      transform: translateX(-20px);

      &::before {
        left: 5px;
        right: auto;
      }
    }

    &::before {
      content: "";
      position: absolute;
      bottom: 100%;
      border-width: 8px;
      border-style: solid;
      border-color: transparent transparent #fff transparent;
    }

    .price-info-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 20px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin: 0;
        font-size: 1em;
        font-weight: 600;
      }

      .close-button {
        appearance: none;
        background: none;
        border: none;
        width: auto;
        font-size: 24px;
        line-height: 1;
        cursor: pointer;
        color: #999;
      }
    }

    .price-info-content {
      padding: 20px;

      .price-item {
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }

        .item-label {
          margin-bottom: 6px;
        }

        .item-value {
          font-weight: 400;

          &.current-price {
            font-weight: 600;
            color: var(--sales-text-color, inherit);

            .vat-info {
              font-size: 0.9em;
              font-weight: 400;
            }
          }

          .discount-value {
            margin-left: 5px;
            font-weight: 600;
          }
        }
      }
    }
  }
}
